export default {
  rateCards: 'Rate Cards',
  channel: 'Channel',
  product: 'Product',
  tactic: 'Tactic',
  monthlySpent: 'Minimum Monthly Media Spend',
  buyingMetric: 'Buying Metric',
  currency: 'Currency',
  buyRate: 'Buy Rate',
  sellRate: 'Sell Rate',
  measure: 'KPI',
  benchmark: 'Benchmark',
  format: 'Format',
  device: 'Device',
  costs: 'Hard Costs',
  hardCosts: 'Hard Cost (Fee / CPM)',
  notes: 'Notes',
  actions: 'Actions',
  addRate: 'Add Rate',
  deleteRateCardModalTitle: 'Delete Rate Card',
  deleteRateCardModalDescription:
    'Are you sure you want to delete this Rate Card? This action cannot be undone.',
  rateCardHasBeenCreated: 'Rate Card has been created successfully.',
  rateCardHasBeenDeleted: 'Rate Card has been deleted successfully.',
  rateCardHasBeenEdited: 'Your changes have been successfully saved.',
  fixValidationErrors: 'Please fix the highlighted fields before saving.'
} as Record<string, string>;
